import get from 'lodash/get';

import React from 'react';
import FullStory, { FullStoryAPI } from 'react-fullstory';

import LogRocket from 'logrocket';

import Browser from './Browser';

const Recording = {};

/**
 * Should this set of actions get log rocket?
 * @param actionsPayload
 * @returns {boolean}
 */
Recording.shouldEnableLogRocket = actionsPayload => {
  const enableFullstory1 =
    Browser.getParameterValue(
      'enable-fullstory',
      get(actionsPayload, 'actions[0].ads[0].url', '')
    ) || false;

  const enableFullstory2 =
    Browser.getParameterValue(
      'enable-fullstory',
      get(actionsPayload, 'actions[0].ads[0].click_through_url', '')
    ) || false;

  if (enableFullstory1 || enableFullstory2) {
    return true;
  }

  return false;
};

/**
 * Should this set of actions get full story?
 * @type {shouldEnableLogRocket}
 */
Recording.shouldEnableFullStory = Recording.shouldEnableLogRocket;

Recording.shouldEnableSessionStack = Recording.shouldEnableLogRocket;

/**
 * Enable log rocket using the payload provided
 * @param actionsPayload will be props in ContentView or serverPayload.data elsewhere.
 */
Recording.enableLogRocket = actionsPayload => {
  console.log('initializing logrocket!');
  LogRocket.init('ltzcc2/e2dev');
  console.log('logrocket actions payload: ', actionsPayload);
  // eslint-disable-next-line no-use-before-define
  const tv = Recording.getTrackingVars(actionsPayload);
  if (tv.imprId) {
    const userId = `impression_id:${tv.imprId}`;
    console.log(`for logrocket, identifying user as ${userId}`);
    LogRocket.identify(userId);
  }
  if (tv.pubUid) {
    const userId = `pub_uid:${tv.pubUid}`;
    console.log(`for logrocket, identifying user as ${userId}`);
    LogRocket.identify(userId);
  }
  // eslint-disable-next-line no-unused-vars
  LogRocket.getSessionURL(sessionURL => {
    window.server.logForImprIds('Recording_Enabled');
  });
};

Recording.getTrackingVars = actionsPayload => {
  const imprId = get(actionsPayload, 'actions[0].ads[0].impression_id', '');
  const trackingPelUrl = get(actionsPayload, 'actions[0].ads[0].tracking_pixels[0]', '');
  const pubUid = Browser.getParameterValue('pub_uid', trackingPelUrl);
  return { pubUid, imprId };
};

/**
 * Get the full story tag
 * @deprecated Use enableFullStory in preload() instead.
 * @param payload
 * @returns {*}
 */
Recording.getFullStory = actionsPayload => {
  console.log('initializing fullstory!');
  console.log('fullstory actions payload: ', actionsPayload);
  const tv = Recording.getTrackingVars(actionsPayload);
  let userId = null;
  if (tv.imprId) {
    userId = `impression_id:${tv.imprId}`;
  } else if (tv.pubUid) {
    userId = `pub_uid:${tv.pubUid}`;
  }
  if (userId) {
    console.log(`for fullstory, identifying user as ${userId}`);
    FullStoryAPI('identify', userId);
  }
  return <FullStory org="J3AWW" />;
};

/**
 * TODO: tbh, I'd prefer to figure out how to leverage the code in react-fullstory
 * even though this snippet was provided by fullstory for us specifically in their interface.
 *
 * NOTE: this simply injects itself prior to the first script tag on the document object.
 */
Recording.loadFullStory = () => {
  window['_fs_debug'] = false;
  window['_fs_host'] = 'fullstory.com';
  window['_fs_script'] = 'edge.fullstory.com/s/fs.js';
  window['_fs_org'] = 'J3AWW';
  window['_fs_namespace'] = 'FS';
  (function(m,n,e,t,l,o,g,y){
    if (e in m) {if(m.console && m.console.log) { m.console.log('FullStory namespace conflict. Please set window["_fs_namespace"].');} return;}
    g=m[e]=function(a,b,s){g.q?g.q.push([a,b,s]):g._api(a,b,s);};g.q=[];
    o=n.createElement(t);o.async=1;o.crossOrigin='anonymous';o.src='https://'+window['_fs_script'];
    y=n.getElementsByTagName(t)[0];y.parentNode.insertBefore(o,y);
    g.identify=function(i,v,s){g(l,{uid:i},s);if(v)g(l,v,s)};g.setUserVars=function(v,s){g(l,v,s)};g.event=function(i,v,s){g('event',{n:i,p:v},s)};
    g.shutdown=function(){g("rec",!1)};g.restart=function(){g("rec",!0)};
    g.log = function(a,b) { g("log", [a,b]) };
    g.consent=function(a){g("consent",!arguments.length||a)};
    g.identifyAccount=function(i,v){o='account';v=v||{};v.acctId=i;g(o,v)};
    g.clearUserCookie=function(){};
  })(window,document,window['_fs_namespace'],'script','user');
};

Recording.enableFullStory = actionsPayload => {
  console.log('initializing fullstory!');
  Recording.loadFullStory();
  console.log('fullstory actions payload: ', actionsPayload);
  const tv = Recording.getTrackingVars(actionsPayload);
  let userId = null;
  if (tv.imprId) {
    userId = `impression_id:${tv.imprId}`;
  } else if (tv.pubUid) {
    userId = `pub_uid:${tv.pubUid}`;
  }
  if (window.FS) {
    console.log(`for fullstory, identifying user as ${userId}`);
    window.FS.identify(userId);
  }
};

Recording.loadSessionStack = () => {
  (function(a, b) {
    const c = window;
    // eslint-disable-next-line no-sequences,no-unused-expressions
    (c.SessionStackKey = a), (c[a] = c[a] || { t: b, q: [] });
    for (
      let d = ['start', 'stop', 'identify', 'getSessionId', 'log', 'setOnDataCallback'], e = 0;
      e < d.length;
      e += 1
    )
      // eslint-disable-next-line no-shadow
      (function(b) {
        c[a][b] =
          c[a][b] ||
          function() {
            // eslint-disable-next-line prefer-rest-params
            c[a].q.push([b].concat([].slice.call(arguments, 0)));
          };
      })(d[e]);
    const f = document.createElement('script');
    // eslint-disable-next-line no-sequences,no-unused-expressions
    (f.async = 1),
      (f.crossOrigin = 'anonymous'),
      (f.src = 'https://cdn.sessionstack.com/sessionstack.js');
    const g = document.getElementsByTagName('script')[0];
    g.parentNode.insertBefore(f, g);
  })('SessionStack', 'f2a65ef9defc498faac7983ed754e101');
};

Recording.enableSessionStack = actionsPayload => {
  console.log('initializing sessionstack!');
  Recording.loadSessionStack();
  if (window.SessionStack) {
    // eslint-disable-next-line no-use-before-define
    const tv = Recording.getTrackingVars(actionsPayload);
    const parms = {};
    if (tv.imprId) {
      parms.impressionId = `${tv.imprId}`;
    }
    if (tv.pubUid) {
      // leaving this open to be userId of multiple types
      // like the other providers.
      parms.userId = `pub_uid:${tv.pubUid}`;
    }
    if (parms.impressionId || parms.userId) {
      Object.keys(parms).forEach(k => {
        console.log(`for sessionstack, identifying ${k} as ${parms[k]}`);
      });
      window.SessionStack.identify(parms);
    }
  } else {
    console.warn('unable to find window.sessionstack!');
  }
};

export default Recording;
